import React, { useEffect, useState } from "react";
import { ChevronDown } from "lucide-react";
import { siteInfo, bioData } from "../../data/mockData";

const HeroSection = () => {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setLoaded(true), 200);
    return () => clearTimeout(timer);
  }, []);

  const scrollToWork = () => {
    document.querySelector("#work")?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section
      id="hero"
      className="relative min-h-screen flex items-center justify-center overflow-hidden"
      style={{ background: "#0a0a0a" }}
    >
      {/* Subtle grain overlay */}
      <div
        className="absolute inset-0 opacity-[0.03] pointer-events-none"
        style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg viewBox='0 0 256 256' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noiseFilter'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noiseFilter)'/%3E%3C/svg%3E")`,
        }}
      />

      {/* Warm ambient glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] rounded-full opacity-[0.04]" 
        style={{ background: "radial-gradient(circle, #c8a55c 0%, transparent 70%)" }} 
      />

      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-12 w-full">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          {/* Text Content */}
          <div className={`transition-all duration-1000 ${loaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
            <p
              className="text-[#c8a55c] text-sm tracking-[0.3em] uppercase mb-6"
              style={{ fontFamily: "'Open Sans', sans-serif", fontWeight: 600 }}
            >
              Filmmaker & Storyteller
            </p>
            <h1
              className="text-[#f5f0e8] text-6xl sm:text-7xl lg:text-8xl leading-[0.9] mb-8"
              style={{ fontFamily: "'Bebas Neue', sans-serif" }}
            >
              Steve<br />
              <span className="text-[#c8a55c]">Sattler</span><br />
              Films
            </h1>
            <p
              className="text-[#c0b8a8] text-base max-w-lg leading-relaxed mb-10"
              style={{ fontFamily: "'Open Sans', sans-serif", fontWeight: 300 }}
            >
              Steve Sattler of Steve Sattler Films is an award-winning cinematographer and director whose work reflects a deep background in film, video, and visual storytelling. Known for combining strong technical craft with originality and emotion, Steve brings creativity, artistry, and a distinctive cinematic eye to every project, from award-winning films and video productions to dynamic music videos and original songwriting. His work is driven by a passion for meaningful images, powerful storytelling, and creative expression, making Steve Sattler Films a place where professional excellence and artistic vision come together.
            </p>
            <button
              onClick={scrollToWork}
              className="inline-flex items-center gap-3 text-[#c8a55c] border border-[#c8a55c]/30 px-8 py-3 hover:bg-[#c8a55c]/10 transition-all duration-300 group"
              style={{ fontFamily: "'Open Sans', sans-serif", fontWeight: 500, fontSize: "0.85rem", letterSpacing: "0.15em" }}
            >
              VIEW WORK
              <ChevronDown className="w-4 h-4 group-hover:translate-y-1 transition-transform duration-300" />
            </button>
          </div>

          {/* Hero Image - Caricature Portrait */}
          <div className={`relative flex justify-center lg:justify-end transition-all duration-1000 delay-300 ${loaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
            <div className="relative">
              {/* Decorative frame */}
              <div className="absolute -inset-4 border border-[#c8a55c]/15 pointer-events-none" />
              <div className="absolute -inset-8 border border-[#c8a55c]/5 pointer-events-none" />
              <img
                src={bioData.images.caricature}
                alt="Steve Sattler"
                className="w-72 sm:w-80 lg:w-96 object-contain hover:grayscale-0 transition-all duration-700"
              />
              {/* Corner accent */}
              <div className="absolute -bottom-2 -right-2 w-16 h-16 border-b-2 border-r-2 border-[#c8a55c]/30" />
              <div className="absolute -top-2 -left-2 w-16 h-16 border-t-2 border-l-2 border-[#c8a55c]/30" />
            </div>
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-10 left-1/2 -translate-x-1/2 flex flex-col items-center gap-3 animate-bounce">
        <span
          className="text-[#8a8070] text-xs tracking-[0.2em] uppercase"
          style={{ fontFamily: "'Open Sans', sans-serif" }}
        >
          Scroll
        </span>
        <div className="w-px h-8 bg-gradient-to-b from-[#c8a55c]/50 to-transparent" />
      </div>
    </section>
  );
};

export default HeroSection;
